import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';

interface Item {
  label: string;
  value: string;
}

@Component({
    selector: 'c-select-modal',
    templateUrl: './select-modal.component.html',
    styleUrls: ['./select-modal.component.scss'],
    standalone: false
})
export class SelectModalComponent implements OnInit {
  // Inputs
  @Input() options: Item[] = [];
  @Input() label = '';
  @Input() enableSearch: boolean;
  @Input() noResultsLabel: string = 'select.no-results';
  @Input() selectedValue: string;

  @Output() close = new EventEmitter();
  @Output() select = new EventEmitter<string>();

  filteredOptions: Item[] = [];

  faXmark = faXmark;
  checkIcon = faCheck;

  ngOnInit(): void {
    this.filteredOptions = this.options;
  }

  isSelected(value: string): boolean {
    return value === this.selectedValue;
  }

  searchChange(event): void {
    const searchQuery: string = event?.detail?.value ?? '';
    if (!searchQuery) {
      this.filteredOptions = [...this.options];
      return;
    }
    this.filteredOptions = this.options.filter((option) =>
      option.label.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  trackItems(index: number, item: Item) {
    return item.value;
  }

  onClose(): void {
    this.close.emit();
  }

  onSelect(value: string): void {
    this.select.emit(value);
  }
}
